import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import { get } from "lodash";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

import { Field, FieldError, FieldLabel } from "@/components/ui/field";
import { Input } from "@/components/ui/input";

import { REQUIRED_MARK } from "./fieldClasses";

// The country selector + libphonenumber formatting come from
// react-phone-number-input (the same widget the Contact forms use). It emits
// E.164 ("+13304284366"), which is exactly what the phone column stores, and
// `undefined` when cleared — normalized to null to match the form's empty
// convention.
const FormPhone = ({
  name,
  label,
  required,
  placeholder,
  disabled,
  defaultCountry = "US",
  id,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name);
  const inputId = id ?? name;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Field data-invalid={error ? true : undefined}>
          {label && (
            <FieldLabel
              htmlFor={inputId}
              className={required ? REQUIRED_MARK : undefined}
            >
              {label}
            </FieldLabel>
          )}
          <PhoneInput
            id={inputId}
            name={field.name}
            international
            defaultCountry={defaultCountry}
            placeholder={placeholder}
            disabled={disabled}
            value={field.value ?? undefined}
            onChange={value => field.onChange(value ?? null)}
            onBlur={field.onBlur}
            inputComponent={Input}
            aria-required={required || undefined}
            aria-invalid={error ? true : undefined}
          />
          <FieldError>{error?.message}</FieldError>
        </Field>
      )}
    />
  );
};

FormPhone.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  defaultCountry: PropTypes.string,
  id: PropTypes.string,
};

export default FormPhone;
